import React, { useContext, createContext, ReactNode } from 'react';

interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
	to: string;
	children: ReactNode;
}

type SdsNavContextType = {
	LinkComponent:
		| React.ComponentType<LinkProps>
		| ((props: LinkProps) => React.ReactElement);
};

type NavProviderProps = {
	children: ReactNode;
	linkComponent: React.ComponentType<LinkProps>;
};

export const SdsNavContext = createContext<SdsNavContextType>({
	LinkComponent: ({ children, to, ...props }: LinkProps) => (
		<a {...props} href={to}>
			{children}
		</a>
	),
});

export function SdsNavProvider({ children, linkComponent }: NavProviderProps) {
	return (
		<SdsNavContext.Provider value={{ LinkComponent: linkComponent }}>
			{children}
		</SdsNavContext.Provider>
	);
}
 
export function useNavContext() {
	return useContext(SdsNavContext);
}
